import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {SchedulePromotionReportModel} from "./schedule-promotion-report.model";

@Component({
    selector: "wbo-schedule-promotion-report-page",
    templateUrl: "./schedule-promotion-report-page.component.html",
    providers: [provideReportModel(SchedulePromotionReportModel)]
})
export class SchedulePromotionReportPageComponent extends AbstractReportPage {
    constructor(public model: SchedulePromotionReportModel) {
        super();
    }
}
